var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      attrs: {
        "md-active": _vm.active,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false
      },
      on: {
        "update:mdActive": function($event) {
          _vm.active = $event
        },
        "update:md-active": function($event) {
          _vm.active = $event
        }
      }
    },
    [
      _c("md-dialog-title", [
        _vm._v(_vm._s(_vm.i18n.lbl_sub()) + " - " + _vm._s(_vm.sub.Description))
      ]),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_exchange_asset(), value: _vm.sub.Asset }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_balance(), value: _vm.sub.Balance }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_my_wallet(), value: _vm.sub.WalletId }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "transfer-inputs" }, [
        _c(
          "div",
          { staticClass: "input-wrap" },
          [
            _c("input-field", {
              attrs: { label: _vm.i18n.lbl_amount() },
              on: {
                blur: function($event) {
                  return _vm.checkAmount()
                }
              },
              model: {
                value: _vm.amount,
                callback: function($$v) {
                  _vm.amount = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "amount"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.subWalletsByCurrency.length
          ? _c(
              "div",
              { staticClass: "input-wrap" },
              [
                _c("select-field2", {
                  attrs: {
                    values: _vm.subWalletsByCurrency,
                    label: _vm.i18n.lbl_my_wallet()
                  },
                  model: {
                    value: _vm.receiver,
                    callback: function($$v) {
                      _vm.receiver = $$v
                    },
                    expression: "receiver"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.close }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isSend },
              on: { click: _vm.transfetToWallet }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_send()))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02177560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02177560","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/TransferSubModal.vue
// module id = NU/M
// module chunks = 1